import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AccountsFilterDto } from '../../common/interfaces/accounts-filter-dto';
import { Observable } from 'rxjs';
import { PaginatedSearchResponse } from '../../common/interfaces/paginated-search-response';
import { SsoUserDetailsDto } from '../../common/interfaces/sso-user-details-dto';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class AccountsSearchService {
    private http = inject(HttpClient);
    private env = inject(envToken);

    accountsSearchUrl = '';

    constructor() {
        this.accountsSearchUrl = this.env.apiUrl + '/api/v1/sso-user-details';
    }

    search(enterpriseId: number, account: AccountsFilterDto): Observable<PaginatedSearchResponse<SsoUserDetailsDto>> {
        let params = new HttpParams()
            .set('searchTerm', account.searchTerm ?? '')
            .set('organizationId', account.organizationId ?? '')
            .set('emailVerified', account.isEmailVerified ?? '')
            .set('enabled', account.enabled ?? '')
            .set('isEnterpriseAdmin', account.isEnterpriseAdmin ?? '')
            .set('page', account.page)
            .set('size', account.itemsPerPage)
            .set('sort', account.sortBy + ',' + account.sortOrder)
            .set('flagged', !!account.flagged)
            .set('locked', !!account.locked);

        if (enterpriseId > 0) {
            params = params.append('enterpriseId', enterpriseId);
        }
        if (account?.excludedUserIds) {
            params = params.append('excludedUserIds', account.excludedUserIds.toString());
        }

        return this.http.get<PaginatedSearchResponse<SsoUserDetailsDto>>(`${this.accountsSearchUrl}/search`, {
            params
        });
    }

    findById(id: string): Observable<SsoUserDetailsDto> {
        return this.http.get<SsoUserDetailsDto>(`${this.accountsSearchUrl}/${id}`, {});
    }
}
